import { getIsProduction } from "@faire/help-center-utils/serialized-data/getEnvName";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { isE2E } from "@faire/web--source/common/user-agent/isE2E";
import React, { Suspense } from "react";
import { lazy } from "react";

const LazyDevTools = lazy(() =>
  import(
    /* webpackChunkName: "help-center-dev-tools" */ "@faire/web--source/common/dev-tools/DevTools"
  ).then((m) => ({ default: m.DevTools }))
);

export const DevTools = React.memo(() => {
  const isSSR = useIsSSR();
  if (getIsProduction() || isE2E() || isSSR) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <LazyDevTools />
    </Suspense>
  );
});
